'use client';

import { useState } from 'react';
import { useConfig } from '../../components/ConfigProvider';

const FREE_FEATURES = [
  '1 lieu',
  '1 utilisateur',
  '25 concerts',
  '50 Mo de stockage',
];

const PAID_FEATURES = [
  '100 lieux',
  '100 utilisateurs',
  '2 000 concerts',
  '5 Go de stockage',
  'Notifications automatiques',
  'Envoi de contrats',
  'Calendriers partagés',
];

type Cycle = 'monthly' | 'annual';

export default function PricingPage() {
  const { appUrl: APP_URL } = useConfig();
  const [cycle, setCycle] = useState<Cycle>('monthly');

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold text-slate-900 dark:text-white">Nos tarifs</h1>
        <p className="text-lg text-slate-600 dark:text-slate-400 mt-2">Choisissez le plan adapté à votre structure.</p>

        <div className="inline-flex rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden mt-6">
          <button
            type="button"
            className={`px-4 py-2 font-medium transition-colors ${cycle === 'monthly' ? 'bg-blue-600 text-white' : 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300'}`}
            onClick={() => setCycle('monthly')}
          >
            Mensuel
          </button>
          <button
            type="button"
            className={`px-4 py-2 font-medium transition-colors ${cycle === 'annual' ? 'bg-blue-600 text-white' : 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300'}`}
            onClick={() => setCycle('annual')}
          >
            Annuel{' '}
            <span className="ml-1 text-xs bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300 rounded-full px-2 py-0.5">
              -20%
            </span>
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-6 flex flex-col">
          <h3 className="text-xl font-bold text-slate-900 dark:text-white">Gratuit</h3>
          <p className="text-slate-500 dark:text-slate-400 mb-4">Pour débuter</p>
          <div className="text-3xl font-bold text-slate-900 dark:text-white mb-4">0&euro;</div>
          <ul className="space-y-2 mb-6 flex-1">
            {FREE_FEATURES.map((f) => (
              <li key={f} className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
                <span className="text-green-600 dark:text-green-400">✓</span>{f}
              </li>
            ))}
          </ul>
          <a
            href={`${APP_URL}/admin/auth/signup`}
            className="inline-flex items-center justify-center px-4 py-2 rounded-lg border-2 border-blue-600 text-blue-600 font-medium hover:bg-blue-50 dark:hover:bg-blue-950/40 transition-colors"
          >
            Commencer gratuitement
          </a>
        </div>

        <div className="bg-white dark:bg-slate-800 rounded-lg border-2 border-blue-600 p-6 flex flex-col shadow-lg">
          <h3 className="text-xl font-bold text-slate-900 dark:text-white">Premium</h3>
          <p className="text-slate-500 dark:text-slate-400 mb-4">Pour les professionnels</p>
          <div className="text-3xl font-bold text-slate-900 dark:text-white mb-4">
            {cycle === 'monthly' ? (
              <>29&euro;<span className="text-base font-normal text-slate-500 dark:text-slate-400"> /mois</span></>
            ) : (
              <>278&euro;<span className="text-base font-normal text-slate-500 dark:text-slate-400"> /an</span></>
            )}
          </div>
          <ul className="space-y-2 mb-6 flex-1">
            {PAID_FEATURES.map((f) => (
              <li key={f} className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
                <span className="text-green-600 dark:text-green-400">✓</span>{f}
              </li>
            ))}
          </ul>
          <a
            href={`${APP_URL}/admin/auth/signup`}
            className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors"
          >
            Passer au Premium
          </a>
        </div>
      </div>
    </div>
  );
}
